var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%", position: "relative" } }, [
    _c("div", { staticClass: "flex", staticStyle: { height: "100%" } }, [
      _c("div", { staticClass: "history" }, [
        _c(
          "div",
          { staticClass: "select flex" },
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "choose",
                class: _vm.chooseIndex === index ? "check" : "uncheck",
                on: {
                  click: function ($event) {
                    return _vm.changeClick(item, index)
                  },
                },
              },
              [_c("span", [_vm._v(_vm._s(item.name))])]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "charts" },
          [_c("loadEchart", { ref: "echarts" })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }